import { CellContext } from '@tanstack/react-table';
import timeUtils from '@/utils/timeUtils.ts';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip.tsx';
import { DateRangeFieldDto } from '@/features/dashboard/tours/types/DateRangeFieldDto.ts';
import { CellSecondary } from '@/components/table/_fieldDefinitions/_base/CellSecondary.tsx';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

/**
 * Na liście pokazujemy samą datę startu — po niej się sortuje i ona porządkuje
 * sezon. Pełny zakres zostaje w tooltipie i w eksporcie.
 */
export const dateRangeFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const value = info.getValue() as DateRangeFieldDto | null;

  if (!value?.start) return <EmptyValue />;

  const { main, secondary } = timeUtils.splitDate(value.start);
  const date = (
    <>
      {main}
      <CellSecondary>{secondary}</CellSecondary>
    </>
  );

  // Bez daty końca tooltip powtarzałby komórkę, więc go nie pokazujemy.
  if (!value.end) return date;

  const tooltipContent = `${timeUtils.toTimeFirstDateTimeString(value.start)} - ${timeUtils.toTimeFirstDateTimeString(value.end)}`;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="cursor-default">{date}</span>
      </TooltipTrigger>
      <TooltipContent>{tooltipContent}</TooltipContent>
    </Tooltip>
  );
};
